// Koszt klockow (limit kosztu konstrukcji).
//
// Koszt jest OSOBNA osia od masy: lekki i mocny naped jest drogi, a ciezkie
// obciazniki sa tanie - dlatego optymalizacja "moc za budzet" ma sens.
// Trzymamy koszt w jednym miejscu (tabela po typeId), zeby latwo go stroic
// bez dotykania katalogu czesci.

import { getDefinition, hasDefinition } from './catalog';
import type { PartDefinition, RobotBlueprint } from './types';

/** Koszt klocka w jednostkach budzetu. */
export const PART_COST: Record<string, number> = {
  // Rama i plyty
  beam_1x1: 1,
  beam_2x1: 2,
  beam_3x1: 3,
  beam_4x1: 4,
  beam_6x1: 6,
  beam_1x2: 2,
  plate_2x2: 4,
  bracket_L: 1,
  // Osie i ciezar
  axle_mount: 2,
  ballast_light: 3,
  ballast_heavy: 8,
  // Kola
  wheel_small: 3,
  wheel_medium: 5,
  wheel_large: 7,
  wheel_huge: 12,
  // Zasilanie i naped
  battery: 6,
  drive_unit: 8,
  drive_fast: 9,
  drive_strong: 14,
  // Przekladnie
  gearbox_reduce: 10,
  gearbox_speed: 9,
  gear_8: 4,
  gear_12: 5,
  gear_16: 6,
  sprocket_8: 4,
  sprocket_12: 5,
  chain_drive: 10,
};

/** Koszt klocka. Bez wpisu w tabeli liczymy z masy - nigdy nie zero. */
export function partCost(def: PartDefinition): number {
  return PART_COST[def.typeId] ?? Math.max(1, Math.round(def.massKg * 10));
}

/** Suma kosztu wszystkich klockow konstrukcji. */
export function blueprintCost(blueprint: RobotBlueprint): number {
  let sum = 0;
  for (const part of blueprint.parts) {
    if (!hasDefinition(part.typeId)) continue;
    sum += partCost(getDefinition(part.typeId));
  }
  return sum;
}
